"use strict";

require("../../style/index.css");

require("./index.css");

require("../../tabs/style/css");

require("../../row/style/css");

require("../../col/style/css");